module.exports = __webpack_public_path__ + "media/images/amenities_icons/art_gallery-22d5e08ded85b9165d58f98a436d9d2a.svg";